import React, { useEffect } from "react";
import "./ContactPage.css";
import Aos from 'aos';
import 'aos/dist/aos.css'

const ContactPage = () => {
  useEffect(() =>{
    Aos.init({duration: 1000})
  },[])
  return (
    <section className="contact container section dark:bg-gray-800 " id="contact" >
      <h2 className="section__title dark:text-white">Get In Touch</h2>

      <div className="contact__container" data-aos = "fade-up">
        <div className="contact__info">
          <h3 className="contact__title dark:text-white">Let's talk about everything!</h3>
          <p className="contact__detail dark:text-white">Prefer email? Drop me a line directly!</p>
        </div>

        <form action="" className="contact__form">
          <div className="contact__form-group">
            <div className="contact__form-left">
              <div className="contact__form-dev">
                <input
                  type="text"
                  className="form__input"
                  placeholder="Your Name"
                  required
                />
              </div>

              <div className="contact__form-dev">
                <input
                  type="email"
                  className="form__input"
                  placeholder="Your Email"
                  required
                />
              </div>

              <div className="contact__form-dev">
                <input
                  type="text"
                  className="form__input"
                  placeholder="Subject"
                />
              </div>
            </div>

            <div className="contact__form-right">
              <div className="contact__form-dev">
                <textarea
                  cols="30"
                  rows="10"
                  className="contact__form-input"
                  placeholder="Write Your Message"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn--primary">
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactPage;
